var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"error"},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"text-transform":"capitalize"}},[_c('router-link',{attrs:{"to":{name:'Terms'},"target":"_blank"}},[_vm._v("\n      "+_vm._s(_vm.$t('login.terms'))+"\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4221fc35","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Error.vue
// module id = Fg7u
// module chunks = 1